import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const STORAGE_KEY = 'cooppress_auth'

const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      staff: null,
      isAuthenticated: false,

      setAuth: (token, staff) => {
        localStorage.setItem('cooppress_token', token)
        set({ token, staff, isAuthenticated: true })
      },

      logout: () => {
        localStorage.removeItem('cooppress_token')
        set({ token: null, staff: null, isAuthenticated: false })
      },
    }),
    {
      name: STORAGE_KEY,
      partialize: (state) => ({
        token: state.token,
        staff: state.staff,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        // Sync cooppress_token on rehydrate
        if (state?.token) {
          localStorage.setItem('cooppress_token', state.token)
        }
      },
    },
  ),
)

export default useAuthStore
